import React, { useState } from "react";
import { motion } from "framer-motion";
import Footer from "../Component/Footer";

function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    interest: "Autonomous Delivery Drones",
    message: ""
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        interest: "Autonomous Delivery Drones",
        message: ""
      });
    }, 4000);
  };

  return (
    <div className="bg-[#f8fafc] text-[#0f172a] min-h-screen font-sans selection:bg-gray-900 selection:text-white">
      
      {/* Top Header in Dark Tech Theme (pt-32 ensures Navbar has rich dark background!) */}
      <div className="bg-gradient-to-b from-black via-[#0b1329] to-[#070b14] text-white pt-32 pb-20 px-4 sm:px-6 lg:px-8 border-b border-gray-200/80 relative overflow-hidden">
        
        {/* Subtle Ambient Glow behind title */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[250px] bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <h1 className="text-4xl md:text-5xl font-black tracking-tight mb-4 text-white font-sans">
              Contact NXV Dynamics
            </h1>
            <p className="text-base sm:text-lg text-gray-300 max-w-2xl mx-auto font-normal leading-relaxed">
              Get in touch with our robotics engineering team in Bikaner for technical inquiries, OEM partnerships, and custom hardware development.
            </p>
          </motion.div>
        </div>

      </div>

      {/* 3 Clean Enterprise Info Cards in Apple Luxury Off-White Theme */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-20 mb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Card 1: R&D Lab Headquarters */}
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-white p-8 rounded-3xl border border-gray-200/80 hover:border-gray-300 shadow-[0_15px_35px_rgba(0,0,0,0.06)] hover:shadow-[0_20px_45px_rgba(0,0,0,0.1)] flex flex-col justify-between group transition-all duration-300"
          >
            <div>
              <h3 className="text-xl font-extrabold text-gray-950 mb-2 tracking-tight group-hover:text-blue-600 transition-colors">
                Bikaner Robotics R&D Lab
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 font-normal">
                Our primary research, hardware fabrication, and testing facility where our rovers and drones are built natively from the ground up.
              </p>
            </div>
            <div className="pt-4 border-t border-gray-100 font-mono text-xs text-gray-600">
              <div className="font-bold text-gray-900 mb-1">HEADQUARTERS ADDRESS:</div>
              <div>Engineering College Bikaner, Rajasthan</div>
              <div className="text-gray-500">EIC Department, India - 334004</div>
            </div>
          </motion.div>

          {/* Card 2: Direct Technical Support */}
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-white p-8 rounded-3xl border border-gray-200/80 hover:border-gray-300 shadow-[0_15px_35px_rgba(0,0,0,0.06)] hover:shadow-[0_20px_45px_rgba(0,0,0,0.1)] flex flex-col justify-between group transition-all duration-300"
          >
            <div>
              <h3 className="text-xl font-extrabold text-gray-950 mb-2 tracking-tight group-hover:text-purple-600 transition-colors">
                Direct Communication
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 font-normal">
                Connect with our technical support team, partnership architects, and OEM hardware product specialists.
              </p>
            </div>
            <div className="pt-4 border-t border-gray-100 font-mono text-xs text-gray-700 space-y-1.5">
              <div>
                <span className="text-gray-400 font-bold">EMAIL:</span>{" "}
                <a href="mailto:info@nxvdynamics.com" className="text-blue-600 hover:underline font-bold">info@nxvdynamics.com</a>
              </div>
              <div>
                <span className="text-gray-400 font-bold">HELPLINE 1:</span>{" "}
                <span className="text-gray-900 font-bold">+91 63502 91328</span>
              </div>
              <div>
                <span className="text-gray-400 font-bold">HELPLINE 2:</span>{" "}
                <span className="text-gray-900 font-bold">+91 73078 13301</span>
              </div>
            </div>
          </motion.div>

          {/* Card 3: OEM & Partnerships */}
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-white p-8 rounded-3xl border border-gray-200/80 hover:border-gray-300 shadow-[0_15px_35px_rgba(0,0,0,0.06)] hover:shadow-[0_20px_45px_rgba(0,0,0,0.1)] flex flex-col justify-between group transition-all duration-300"
          >
            <div>
              <h3 className="text-xl font-extrabold text-gray-950 mb-2 tracking-tight group-hover:text-emerald-600 transition-colors">
                OEM & Custom Hardware
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 font-normal">
                Require custom UAV drone payloads, specialized PCB motor drivers, or bulk deployment for university/industrial projects?
              </p>
            </div>
            <div className="pt-4 border-t border-gray-100 font-mono text-xs">
              <span className="inline-block px-3 py-1.5 rounded-full bg-gray-100 text-gray-800 border border-gray-200 font-bold">
                [ AVG RESPONSE: &lt; 2 HOURS ]
              </span>
            </div>
          </motion.div>

        </div>
      </div>

      {/* Main Enterprise Inquiry Form Section in Clean White Theme */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-28">
        <div className="bg-white rounded-3xl border border-gray-200/80 shadow-[0_20px_60px_rgba(0,0,0,0.06)] overflow-hidden grid grid-cols-1 lg:grid-cols-12">
          
          {/* Left Side: Why Partner With Us (Executive High-Contrast Card) */}
          <div className="lg:col-span-5 bg-gradient-to-br from-gray-900 to-gray-950 p-8 sm:p-12 text-white flex flex-col justify-between relative overflow-hidden">
            <div>
              <div className="text-xs font-mono font-bold tracking-widest text-gray-400 uppercase mb-3">
                NXV DYNAMICS // ENTERPRISE ADVANTAGE
              </div>
              <h2 className="text-3xl font-black text-white mb-6 tracking-tight font-sans">
                Why Partner With NXV Dynamics?
              </h2>
              <p className="text-gray-300 text-base leading-relaxed mb-8 font-light">
                We do not assemble third-party kits. Our entire robotics hardware lineup, from 40A dual H-bridge motor drivers to deep-learning weed detection rovers, is designed and engineered natively in our labs.
              </p>

              {/* Highlights List */}
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center text-white shrink-0 font-bold text-sm">
                    01
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">100% In-House Hardware Design</h4>
                    <p className="text-gray-400 text-sm leading-relaxed font-light">Complete control over PCB schematics, firmware architectures, and mechanical CAD assembly.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center text-white shrink-0 font-bold text-sm">
                    02
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">Industrial Grade Stress Testing</h4>
                    <p className="text-gray-400 text-sm leading-relaxed font-light">Our drones and rovers undergo rigorous testing in real-world agricultural and desert terrains.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center text-white shrink-0 font-bold text-sm">
                    03
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-base mb-1">Academic & Institutional Support</h4>
                    <p className="text-gray-400 text-sm leading-relaxed font-light">Incubated and supported by the EIC Department at Engineering College Bikaner, Rajasthan.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Support Badge */}
            <div className="mt-12 pt-6 border-t border-white/10 flex items-center gap-3 text-xs font-mono text-gray-400">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              <span>GLOBAL SUPPORT DESK // ONLINE 24/7</span>
            </div>

          </div>

          {/* Right Side: Clean Executive Inquiry Form */}
          <div className="lg:col-span-7 p-8 sm:p-12 bg-white">
            
            <div className="mb-8">
              <h3 className="text-2xl font-black text-gray-950 mb-2">
                Send an Inquiry to Our Architecture Team
              </h3>
              <p className="text-gray-600 text-sm font-normal">
                Fill out the required parameters below. Our engineering team will review your project requirements and respond within 2 business hours.
              </p>
            </div>

            {submitted ? (
              <motion.div 
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="bg-gray-50 border border-gray-200 rounded-2xl p-8 text-center my-12 shadow-sm"
              >
                <div className="w-14 h-14 bg-gray-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold shadow-md">
                  ✓
                </div>
                <h4 className="text-2xl font-black text-gray-950 mb-2">Inquiry Transmitted Successfully!</h4>
                <p className="text-gray-600 text-sm max-w-md mx-auto mb-6">
                  Thank you for reaching out to NXV Dynamics. Your message has been routed directly to our Bikaner engineering dispatch team.
                </p>
                <span className="text-xs font-mono text-gray-800 font-bold uppercase tracking-widest bg-gray-200/80 px-4 py-2 rounded-full border border-gray-300">
                  TICKET #NXV-{Math.floor(10000 + Math.random() * 90000)} // STATUS: QUEUED FOR REVIEW
                </span>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                      First Name *
                    </label>
                    <input 
                      type="text" 
                      name="firstName"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="e.g. Vikram" 
                      className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-900 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                      Last Name *
                    </label>
                    <input 
                      type="text" 
                      name="lastName"
                      required
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="e.g. Sharma" 
                      className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-900 transition-all"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                      Work Email Address *
                    </label>
                    <input 
                      type="email" 
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="name@company.com" 
                      className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-900 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                      Phone / WhatsApp Number *
                    </label>
                    <input 
                      type="tel" 
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 63502 91328" 
                      className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-900 transition-all"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                    Primary Area of Interest *
                  </label>
                  <select 
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 focus:outline-none focus:bg-white focus:border-gray-900 transition-all font-medium"
                  >
                    <option value="Autonomous Delivery Drones">Autonomous Delivery Drones (UAV Medical Logistics)</option>
                    <option value="Agri-Smart Farming Rovers">Agri-Smart Farming Rovers (LiDAR & Soil Testing)</option>
                    <option value="SNT Smart 3D Printers">SNT Smart 3D Printers (Scan & Cloud Slicing)</option>
                    <option value="Custom Motor Driver PCBs">Custom Motor Driver PCBs (40A Dual H-Bridge)</option>
                    <option value="AI Attendance Systems">Smart AI Attendance Systems (Biometric Vision)</option>
                    <option value="General Partnership & Research">General OEM Partnership & Research Collaboration</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-mono font-bold uppercase tracking-wider text-gray-700 mb-2">
                    Technical Specifications / Project Scope *
                  </label>
                  <textarea 
                    name="message"
                    required
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Describe your project requirements, payload needs, or partnership proposal..." 
                    className="w-full bg-gray-50 border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:bg-white focus:border-gray-900 transition-all resize-none"
                  ></textarea>
                </div>

                <div className="pt-2">
                  <button 
                    type="submit" 
                    className="w-full py-4 px-8 rounded-xl bg-gray-950 hover:bg-black text-white font-black text-sm uppercase tracking-wider transition-all shadow-md hover:shadow-xl hover:scale-[1.01] active:scale-[0.99]"
                  >
                    Transmit Enterprise Inquiry &rarr;
                  </button>
                </div>

                <p className="text-center text-xs text-gray-500 font-mono">
                  🔒 All transmissions are encrypted and reviewed directly by NXV Dynamics engineering team.
                </p>

              </form>
            )}

          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ContactPage;
